import {
  PIIScanList,
  PIIScanListMetadataArgs,
  getPIIScanListMetadata
} from '../../assets/ts/data/pii/pii-scan'
import useServerData from '../use-server-data'

function usePiiScanMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: piiScanMetadata,
    error: piiScanMetadataError,
    fetchData: fetchPiiScanMetadata,
    isLoading: piiScanMetadataIsLoading,
  } = useServerData<PIIScanList, PIIScanListMetadataArgs>(
    getPIIScanListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchPiiScanMetadata,
    piiScanMetadata,
    piiScanMetadataError,
    piiScanMetadataIsLoading,
  }
}

export default usePiiScanMetadata
